import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsRoutingModule } from './settings-routing.module';
import { ProfileComponent } from './profile/profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from '@material-library';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogDisplayAvatarComponent } from './profile/dialog-display-avatar/dialog-display-avatar.component';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import ActivityLogsComponent from './activity-logs/activity-logs.component';
import { DialogDisplayNameComponent } from './profile/dialog-display-name/dialog-display-name.component';
import { ActivityLogItemComponent } from './activity-logs/activity-log-item/activity-log-item.component';
import { ActivityLogDetailComponent } from './activity-logs/activity-log-detail/activity-log-detail.component';
import { DialogEmailChangeComponent } from './profile/dialog-email-change/dialog-email-change.component';
import { DevicesComponent } from './devices/devices.component';
import { SecurityComponent } from './security/security.component';
import { DialogTwofactorComponent } from './security/dialog-twofactor/dialog-twofactor.component';
import { QRCodeModule } from 'angularx-qrcode';
import { BrandingComponent } from './branding/branding.component';
import { DialogPasswordHintComponent } from './security/dialog-password-hint/dialog-password-hint.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { DialogPasswordRecoveryComponent } from './security/dialog-password-recovery/dialog-password-recovery.component';
import { BillingComponent } from './billing/billing.component';
import { NgChartsModule } from 'ng2-charts';
import { BillingProfileComponent } from './billing-profile/billing-profile.component';
import { UpgradePlanComponent } from './upgrade-plan/upgrade-plan.component';

@NgModule({
  declarations: [
    ProfileComponent,
    DialogDisplayAvatarComponent,
    ActivityLogsComponent,
    DialogDisplayNameComponent,
    ActivityLogItemComponent,
    ActivityLogDetailComponent,
    DialogEmailChangeComponent,
    DevicesComponent,
    SecurityComponent,
    DialogTwofactorComponent,
    BrandingComponent,
    DialogPasswordHintComponent,
    DialogPasswordRecoveryComponent,
    BillingComponent,
    BillingProfileComponent,
    UpgradePlanComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    SettingsRoutingModule,
    ComponentsModule,
    MatCardModule,
    MatTooltipModule,
    SharedModule,
    QRCodeModule,
    ColorPickerModule,
    NgChartsModule
  ],
  exports: []
})
export class SettingsModule { }
